import Swiper, { Scrollbar } from 'swiper';

const swiper = new Swiper('.swiper', {
  modules: [Scrollbar],
  slidesPerView: 'auto',
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
});
